import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Footer from "../components/Footer/Footer";
import { NewsForm } from "../components/forms/News/news-form";
import { ProjectForm } from "../components/forms/Project/project-form";
import { SliderForm } from "../components/forms/Slider/slider-form";
import { UserForm } from "../components/forms/User/user-form";
import Header from "../components/Header/Header";
import Complaints from "../pages/(dashboard)/dashboard/complaints/Complaints";
import Events from "../pages/(dashboard)/dashboard/Events/Events";
import DashboardLayout from "../pages/(dashboard)/dashboard/layout";
import News from "../pages/(dashboard)/dashboard/News/News";
import Presses from "../pages/(dashboard)/dashboard/Presse/Presse";
import Projects from "../pages/(dashboard)/dashboard/Projects/Projects";
import Sliders from "../pages/(dashboard)/dashboard/sliders/Sliders";
import Users from "../pages/(dashboard)/dashboard/user/Users";
import About from "../pages/About";
import Login from "../pages/Auth/Login";
import Contact from "../pages/Contact";
import Hiring from "../pages/Hiring";
import Home from "../pages/Home";
import NotFound from "../pages/NotFound";
import Water from "../pages/Water";
import { Page } from "./types";

import { useEffect, useState } from "react";
import { ActionForm } from "../components/forms/Action/action-form";
import { ActivityReportForm } from "../components/forms/ActivityReport/activity-report-form";
import { AdministrationForm } from "../components/forms/Administration/administration-form";
import { BudgetForm } from "../components/forms/Budget/budget-form";
import { CommunicationSupportForm } from "../components/forms/CommunicationSupport/communication-support-form";
import { EventForm } from "../components/forms/Event/event-form";
import { GallerieForm } from "../components/forms/Gallerie/gallerie-form";
import { InquiriesForm } from "../components/forms/Inquiries/inquiries-form";
import { PressForm } from "../components/forms/Press/press-form";
import { RecruitmentForm } from "../components/forms/Recruitment/recruitment-form";
import { StatutsForm } from "../components/forms/Statuts/statuts-form";
import { TeamForm } from "../components/forms/Team/team-form";
import { PasswordChangeForm } from "../components/forms/User/password-change-form";
import { ResetPassword } from "../components/forms/User/reset-password";
import { VideoForm } from "../components/forms/Video/video-form";
import GallyHistory from "../components/PatrimoineSection/GallyHistory";
import GallyNaturelle from "../components/PatrimoineSection/GallyNaturelle";
import GallyRenaturer from "../components/PatrimoineSection/GallyRenaturer";
import GallyVegetaliser from "../components/PatrimoineSection/GallyVegetaliser";
import MarivelCollecteur from "../components/PatrimoineSection/MarivelCollecteur";
import MarivelHistory from "../components/PatrimoineSection/MarivelHistory";
import PatrimoinePhoto from "../components/PatrimoineSection/PatrimoinePhoto";
import PedagogiqueSection from "../components/PedagogiqueSection.tsx/PedagogiqueSection";
import PresseCommunique from "../components/PresseSection/PresseCommunique";
import PresseRetombees from "../components/PresseSection/PresseRetombees";
import ScrollToTop from "../lib/scrollToTop";
import Actions from "../pages/(dashboard)/dashboard/Actions/Actions";
import Budget from "../pages/(dashboard)/dashboard/Budget/Budget";
import Job from "../pages/(dashboard)/dashboard/Job/Job";
import ActivityReport from "../pages/(dashboard)/dashboard/Mediatheque/ActivityReport/ActivityReport";
import Administration from "../pages/(dashboard)/dashboard/Mediatheque/Administration/Administration";
import CommunicationSupport from "../pages/(dashboard)/dashboard/Mediatheque/CommunicationFiles/CommunicationSupport";
import Galleries from "../pages/(dashboard)/dashboard/Mediatheque/Galleries/Galleries";
import Inquiries from "../pages/(dashboard)/dashboard/Mediatheque/Inquiries/Inquiries";
import Statuts from "../pages/(dashboard)/dashboard/Mediatheque/Statuts/Statuts";
import Videos from "../pages/(dashboard)/dashboard/Mediatheque/Videos/Videos";
import Recruitment from "../pages/(dashboard)/dashboard/Recruitment/Recruitment";
import Team from "../pages/(dashboard)/dashboard/team/Team";
import InteractiveCarte from "../pages/Carte/InteractiveCarte";
import CommandePublique from "../pages/Commands/CommandePublique";
import Eco from "../pages/Eco";
import AllEngagment from "../pages/engagements/AllEngagment";
import EventSinglePage from "../pages/Events/EventSinglePage";
import EventsList from "../pages/Events/EventsList";
import Faq from "../pages/Faq";
import AllFinances from "../pages/Finance/AllFinances";
import FinanceSinglePage from "../pages/Finance/FinanceSinglePage";
import ActionsList from "../pages/Iniatives/ActionsList";
import IniativeSinglePage from "../pages/Iniatives/IniativeSinglePage";
import Innovation from "../pages/Innovation";
import Mediatheque from "../pages/Mediatheque/Mediatheque";
import MediathequeActivityReport from "../pages/Mediatheque/MediathequeActivityReport";
import MediathequePhoto from "../pages/Mediatheque/MediathequePhoto";
import MediathequeSupportCommunication from "../pages/Mediatheque/MediathequeSupportCommunication";
import MediathequeVideo from "../pages/Mediatheque/MediathequeVideo";
import MediatheuqeAdministration from "../pages/Mediatheque/MediatheuqeAdministration";
import MissionAndServices from "../pages/MissionAndServices";
import AllNews from "../pages/News/AllNews";
import NewsSinglePage from "../pages/News/NewsSinglePage";
import Gemapi from "../pages/Patrimoine";
import Presse from "../pages/Presse";
import ServiceDetails from "../pages/ServiceDetails";
import PrivateRoute from "../utils/PrivateRoute";
import ListTravaux from "../pages/Travaux/ListTravaux";
import Recherche from "../pages/Recherche";
import TravauxSinglePage from "../pages/Travaux/TravauxSinglePage";
import Policy from "../pages/Policy";
import Legal from "../pages/Legal";
export const pages: Page[] = [
  { path: "/", exact: true, component: Home },
  { path: "/qui-sommes-nous", exact: true, component: About },
  { path: "/innovations", exact: true, component: Innovation },
  { path: "/espace-pédagogique", exact: true, component: PedagogiqueSection },
  { path: "/ouvrages-installations", exact: true, component: Water },
  { path: "/missions", exact: true, component: MissionAndServices },
  { path: "/eco-gestes", exact: true, component: Eco },
  { path: "/recrutement", exact: true, component: Hiring },
  { path: "/gemapi", exact: true, component: Gemapi },
  {
    path: "/gemapi/renaturer-le-ruisseau",
    exact: true,
    component: GallyRenaturer,
  },
  {
    path: "/gemapi/paysage-attractif",
    exact: true,
    component: GallyVegetaliser,
  },
  {
    path: "/gemapi/ruisseau-naturelle",
    exact: true,
    component: GallyNaturelle,
  },
  {
    path: "/gemapi/historique-ru-gally",
    exact: true,
    component: GallyHistory,
  },
  {
    path: "/gemapi/historique-ru-marivel",
    exact: true,
    component: MarivelHistory,
  },
  {
    path: "/gemapi/collecteurs-ru-marivel",
    exact: true,
    component: MarivelCollecteur,
  },

  { path: "/patrimoine/equipements", exact: true, component: PatrimoinePhoto },
  { path: "/contact", exact: true, component: Contact },
  { path: "/evenements", exact: true, component: EventsList },
  { path: "/evenements/:id", exact: true, component: EventSinglePage },

  { path: "/politique-de-confidentialité", exact: true, component: Policy },
    { path: "/mentions-légales", exact: true, component: Legal },


  { path: "/engagements", exact: true, component: AllEngagment },
  { path: "/travaux", exact: true, component: ListTravaux },
  { path: "/travaux/:id", exact: true, component: TravauxSinglePage },

  { path: "/actualités", exact: true, component: AllNews },
  { path: "/actualités/:id", exact: true, component: NewsSinglePage },

  { path: "/commande-publique", exact: true, component: CommandePublique },
  { path: "/mediatheque", exact: true, component: Mediatheque },
  { path: "/mediatheque/photos", exact: true, component: MediathequePhoto },
  {
    path: "/mediatheque/actes-administratifs",
    exact: true,
    component: MediatheuqeAdministration,
  },
  { path: "/mediatheque/videos", exact: true, component: MediathequeVideo },
  {
    path: "/mediatheque/support-communications",
    exact: true,
    component: MediathequeSupportCommunication,
  },
  {
    path: "/mediatheque/rapport-activités",
    exact: true,
    component: MediathequeActivityReport,
  },
  { path: "/actions", exact: true, component: ActionsList },
  { path: "/initiatives/:slug", exact: true, component: IniativeSinglePage },

  { path: "/a-propos-de-nous", exact: true, component: ServiceDetails },

  { path: "/budget", exact: true, component: AllFinances },
  { path: "/budget/:id", exact: true, component: FinanceSinglePage },

  { path: "/carte", exact: true, component: InteractiveCarte },

  { path: "/login", exact: true, component: Login },

  { path: "/presse", exact: true, component: Presse },
  { path: "/presse/communiquées", exact: true, component: PresseCommunique },
  { path: "/presse/retombées", exact: true, component: PresseRetombees },
  {
    path: "/reset-password/:token",
    exact: true,
    component: PasswordChangeForm,
  },
  {
    path: "/reset-password",
    exact: true,
    component: ResetPassword,
  },

  { path: "/questions", exact: true, component: Faq },
  { path: "/recherche", exact: true, component: Recherche },
];

const adminRoutes = [
  {
    path: "/admin-dashboard",
    component: DashboardLayout,
    requiredRoles: ["ADMIN", "ee"],
  },
  { path: "/admin-dashboard/utilisateurs", component: Users },
  { path: "/admin-dashboard/utilisateurs/ajouter", component: UserForm },
  { path: "/admin-dashboard/user/:id", component: UserForm },
  { path: "/admin-dashboard/messages", component: Complaints },
  { path: "/admin-dashboard/actualités", component: News },
  { path: "/admin-dashboard/actualité/ajouter", component: NewsForm },
  {
    path: "/admin-dashboard/actualité/:id",
    component: NewsForm,
  },
  { path: "/admin-dashboard/sliders", component: Sliders },
  { path: "/admin-dashboard/slider/ajouter", component: SliderForm },
  { path: "/admin-dashboard/sliders/:id", component: SliderForm },

  { path: "/admin-dashboard/mediatheque/photos", component: Galleries },
  {
    path: "/admin-dashboard/mediatheque/photos/ajouter",
    component: GallerieForm,
  },
  {
    path: "/admin-dashboard/mediatheque/photos/:id",
    component: GallerieForm,
  },
  { path: "/admin-dashboard/mediatheque/videos", component: Videos },
  {
    path: "/admin-dashboard/mediatheque/videos/ajouter",
    component: VideoForm,
  },
  {
    path: "/admin-dashboard/mediatheque/videos/:id",
    component: VideoForm,
  },
  {
    path: "/admin-dashboard/mediatheque/support-de-communications",
    component: CommunicationSupport,
  },
  {
    path: "/admin-dashboard/mediatheque/support-de-communications/ajouter",
    component: CommunicationSupportForm,
  },
  {
    path: "/admin-dashboard/mediatheque/support-de-communications/:id",
    component: CommunicationSupportForm,
  },

  {
    path: "/admin-dashboard/mediatheque/rapports-activites",
    component: ActivityReport,
  },
  {
    path: "/admin-dashboard/mediatheque/rapports-activites/ajouter",
    component: ActivityReportForm,
  },
  {
    path: "/admin-dashboard/mediatheque/rapports-activites/:id",
    component: ActivityReportForm,
  },

  {
    path: "/admin-dashboard/mediatheque/actes-administratifs",
    component: Administration,
  },
  {
    path: "/admin-dashboard/mediatheque/actes-administratifs/ajouter",
    component: AdministrationForm,
  },
  {
    path: "/admin-dashboard/mediatheque/actes-administratifs/:id",
    component: AdministrationForm,
  },

  {
    path: "/admin-dashboard/mediatheque/statuts",
    component: Statuts,
  },
  {
    path: "/admin-dashboard/mediatheque/statuts/ajouter",
    component: StatutsForm,
  },
  {
    path: "/admin-dashboard/mediatheque/statuts/:id",
    component: StatutsForm,
  },

  {
    path: "/admin-dashboard/mediatheque/enquetes-publiques",
    component: Inquiries,
  },
  {
    path: "/admin-dashboard/mediatheque/enquetes-publiques/ajouter",
    component: InquiriesForm,
  },
  {
    path: "/admin-dashboard/mediatheque/enquetes-publiques/:id",
    component: InquiriesForm,
  },

  { path: "/admin-dashboard/travaux", component: Projects },
  { path: "/admin-dashboard/travaux/ajouter", component: ProjectForm },
  { path: "/admin-dashboard/travaux/:id", component: ProjectForm },
  { path: "/admin-dashboard/evenements", component: Events },
  { path: "/admin-dashboard/evenements/ajouter", component: EventForm },
  { path: "/admin-dashboard/evenements/:id", component: EventForm },

  { path: "/admin-dashboard/initiative", component: Actions },
  { path: "/admin-dashboard/initiative/ajouter", component: ActionForm },
  { path: "/admin-dashboard/initiative/:id", component: ActionForm },

  { path: "/admin-dashboard/presse", component: Presses },
  { path: "/admin-dashboard/presse/ajouter", component: PressForm },
  { path: "/admin-dashboard/presse/:id", component: PressForm },
  { path: "/admin-dashboard/recrutement", component: Recruitment },
  {
    path: "/admin-dashboard/recrutement/nouveau-offre",
    component: RecruitmentForm,
  },
  { path: "/admin-dashboard/recrutement/:id", component: RecruitmentForm },
  { path: "/admin-dashboard/candidatures-emploi", component: Job },
  { path: "/admin-dashboard/organigramme-equipe", component: Team },
  { path: "/admin-dashboard/organigramme-equipe/nouveau", component: TeamForm },
  { path: "/admin-dashboard/organigramme-equipe/:id", component: TeamForm },
  { path: "/admin-dashboard/budgets", component: Budget },
  { path: "/admin-dashboard/budget/ajouter", component: BudgetForm },
  { path: "/admin-dashboard/budget/:id", component: BudgetForm },
];

const PublicRoute = ({ element }: any) => {
  return element;
};

const HeaderRoutes = () => {
  const location = useLocation();
  const [showHeader, setShowHeader] = useState(
    !location.pathname.startsWith("/admin")
  );

  useEffect(() => {
    setShowHeader(!location.pathname.startsWith("/admin"));
  }, [location]);

  return (
    <>
      <ScrollToTop />
      {showHeader && <Header />}

      <div className="">
        {" "}
        {/* Add padding-bottom here */}
        <Routes>
          {pages.map(({ component: Component, path }) => (
            <Route
              key={path}
              element={<PublicRoute element={<Component />} />}
              path={path}
            />
          ))}

          {adminRoutes.map(({ component: Component, path, requiredRoles }) => (
            <Route
              key={path}
              element={
                <PrivateRoute
                  element={<Component />}
                  requiredRoles={requiredRoles}
                />
              }
              path={path}
            />
          ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>

      {showHeader && <Footer />}
    </>
  );
};

const MyRoutes = () => {
  return (
    <BrowserRouter>
      <HeaderRoutes />
    </BrowserRouter>
  );
};

export default MyRoutes;
